import { Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';

import { colors } from 'styles';

interface IProps {
  data?: number[];
  color?: string;
  name?: string;
  height?: number;
  isNumber?: boolean;
}

const SenslaChart: React.FC<IProps> = ({ data, color, name, height, isNumber }) => {
  const formattedData = useMemo(() => {
    if (!data) return [];
    const newData = Object.values(data);
    return newData.map((item: any) => (item * 100).toFixed(1));
  }, data);

  const options = {
    chart: {
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        hollow: {
          margin: 100,
          size: '50%',
          background: 'transparent',
          image: undefined,
        },
        dataLabels: {
          name: {
            show: true,
            fontFamily: 'Montserrat',
            fontSize: '1rem',
            color: colors.textGrey3e,
            fontWight: 'bold',
          },
          value: {
            show: true,
            fontFamily: 'Montserrat',
            fontSize: '2rem',
            color: colors.textGrey3e,
            fontWeight: '900',
          },
          total: {
            show: true,
            label: name ? name : 'Sensla Score',
            fontSize: '0.9rem',
            fontFamily: 'Montserrat',
            formatter: function (w: any) {
              // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
              if (isNumber) {
                return (w.config.series[0] / 10).toFixed(1);
              } else {
                return `${w.config.series[0]}%`;
              }
            },
          },
        },
        track: {
          show: true,
          margin: 5,
        },
      },
    },
    labels: name ? [name] : ['Sensla Score', 'Energy', 'Efficacy', 'Constancy'],
    colors: color
      ? [color]
      : [colors.blueBrand, colors.orangeBrand, colors.redBrand, colors.greenBrand],
    legend: {
      show: true,
      horizontalAlign: 'center',
      floating: false,
      fontSize: '16px',
      position: 'bottom',
      fontFamily: 'Montserrat',
      fontWeight: 'bold',
      offsetX: 0,
      offsetY: 0,
      labels: {
        useSeriesColors: true,
      },
      markers: {
        width: 0,
        onClick: undefined,
      },
      formatter: function (seriesName: any, opts: any) {
        if (opts.seriesIndex === 0) {
          return '';
        }
        return opts.w.globals.series[opts.seriesIndex]
          ? `${seriesName}: ${opts.w.globals.series[opts.seriesIndex]}%`
          : '';
      },
    },
  };

  return (
    <Grid>
      <Chart
        options={options}
        series={formattedData}
        type="radialBar"
        height={height ? height : 320}
      />
    </Grid>
  );
};

export { SenslaChart };
